import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const DevelopmentRequestReplyCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `تم الرد على عرض تطوير خاص بك`
          : 'Your development offer has been replied to'
      }
    />
  )
}

export default DevelopmentRequestReplyCover
